<div xpoDialog class="switch-ram-roles-dialog">
  <h1 mat-dialog-title>
    Change RAM Roles
  </h1>

  <div mat-dialog-content>
    <form [formGroup]="securityRolesForm" class="ram-roles-form">
      <h3>RAM Roles</h3>
      <mat-checkbox [checked]="isAllSelected()" (change)="toggleSelectAll($event.checked)">
        Select All
      </mat-checkbox>
      <div formArrayName="selectedRamRoles">
        <div *ngFor="let role of ramRolesOptions; let i = index">
          <mat-checkbox [formControlName]="i">{{ role }}</mat-checkbox>
        </div>
      </div>
    </form>
  </div>

  <div mat-dialog-actions>
    <button mat-flat-button xpoButton (click)="ramRolesSelection()">Switch</button>
    <button mat-stroked-button xpoButton (click)="close()">Close</button>
  </div>
</div>
